export const documentBusUrls = {
  updateSaleOrder: '/UpdateSaleOrderWebStatus',
  updateOdvPaymentMethod: '/UpdateSaleOrderWebPaymentMethod',
  notifyCreateRequest: '/NotifyCreateRequestDispatch',
  searchSaleOrderId: '/SearchBySaleOrderId?OrderSaleId=',
  searchIntegrationDocuments: '/SearchIntegrationDocuments',
  listBranchOffices: '/BranchOffices/',
  detailDocument: '/IntegrationInvoiceDetail/',
}
